import iconfont from "./iconfont.vue";

const iconfontPlugin = {
  name: "Iconfont",
  install(app: any): void {
    // 全局挂载
    app.component("Iconfont", iconfont);
  }
};

export default iconfontPlugin;
